import { useEffect, useState } from "react"
import { LinearProgressWithLabel } from "../../components/LinearProgressWithLabel/LinearProgressWithLabel"
import { Label } from "../../components/Typography/Typography"
import { useFlightplanEditStore } from "../../zstore/FlightplanEditStore"
import { useFlightplanEditorStyles } from "./FlightplanEditorStyles"

export const FlightplanCompletedLines = () => {
    const { classes } = useFlightplanEditorStyles()
    const selectedFlightplan = useFlightplanEditStore((state) => state.selectedFlightplan)
    const flightPlannedLines = useFlightplanEditStore((state) => state.selectedFlightplanPlannedLines)

    const [calculations, setCalculations] = useState({ linePct: 0, distPct: 0 })

    /**
     * Calculate line percentages when number of lines changes.
     */
    useEffect(() => {
        const lines_total = flightPlannedLines.length
        let lines_flown = 0
        let distance_flown = 0
        let distance_total = 0

        flightPlannedLines.forEach((line) => {
            const counted = Boolean(line.mission_name)
            if (counted) {
                lines_flown++
                distance_flown += line.planned_distance || 0
            }
            distance_total += line.planned_distance || 0
        })

        const getPct = (val: number) => Math.round(val * 1000) / 10 || 0
        const linePct = getPct(lines_flown / lines_total)
        const distPct = getPct(distance_flown / distance_total)

        setCalculations({ linePct, distPct })
    }, [flightPlannedLines.length])

    return (
        <>
            <Label gutterBottom="sm">Completed Lines</Label>
            {Object.values(calculations).map((value, i) => {
                const supportingText = `(by ${i === 0 ? "line count" : "distance"}${
                    selectedFlightplan.status === "Complete" ? ` - actually ${value}%` : ""
                })`

                return (
                    <LinearProgressWithLabel
                        key={i}
                        value={selectedFlightplan.status === "Complete" ? 100 : value}
                        renderValue={(value: number) => `${value}% ${supportingText}`}
                        className={classes.input__md}
                    />
                )
            })}
        </>
    )
}
